<template>
	<div class="pages df wao hao">
		<template v-if="type==1">
			<div class="num"><em>{{now}}</em>/{{all}}</div>
			<div class="prev df hao" @click="tapPage('prev')"><em></em><span v-if="now>1">上一页</span></div>
			<div class="next df hao" @click="tapPage('next')"><span v-if="now<all">下一页</span><em></em></div>
		</template>
		<template v-if="type==2">
			<div class="prev2" :class="{ none: now==1 }" @click="tapPage('prev')"></div>
			<div class="num2" :class="{ cur: now==v, none: v==='' }" v-for="(v,i) in getGroup()" @click="tapPage(v)">{{v||'...'}}</div>
			<div class="next2" :class="{ none: now==all }" @click="tapPage('next')"></div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'pages',
	props: {
		type: {
			default: 1,
		},
		all: {
			default: 1,
		},
		now: {
			default: 1,
		},
	},
	data () {
		return {}
	},
	methods: {
		getGroup(){
			let arr = []
			let ad = 4 // 左右阙值
			let min = 1
			let now = this.now
			let max = this.all
			let start = now-ad
			let end = now+ad
			
			if(start<min){
				start = min
			}
			if(end>max){
				end = max
			}
			
			if(start-min>=1){
				arr.push(min)
				if(start-min>1){
					arr.push('')
				}
			}
			for(let i=start;i<=end;i++){
				arr.push(i)
			}
			if(max-end>=1){
				if(max-end>1){
					arr.push('')
				}
				arr.push(max)
			}
			return arr
		},
		tapPage(page){
			if(page=='prev'&&this.now<=1){
				return
			}else if(page=='next'&&this.now>=this.all){
				return
			}
			this.$parent && this.$parent.tapPage && this.$parent.tapPage(page);
		},
	},
}
</script>

<style lang="less" scoped>
	.pages{
		.num{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			line-height: 14px;
			em{
				color: #006F56;
			}
		}
		.prev{
			margin-left: 12px;
			cursor: pointer;
			height: 28px;
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid #DBDBDB;
			padding: 8px;
			span{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #7F7F7F;
				line-height: 16px;
				margin-left: 2px;
			}
			em{
				width: 12px;
				height: 12px;
				background: url(../../assets/img/prev.png) center center / 100% auto no-repeat;
			}
		}
		.next{
			margin-left: 8px;
			cursor: pointer;
			height: 28px;
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid #DBDBDB;
			padding: 8px;
			span{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #7F7F7F;
				line-height: 16px;
				margin-right: 2px;
			}
			em{
				width: 12px;
				height: 12px;
				background: url(../../assets/img/next.png) center center / 100% auto no-repeat;
			}
		}
		.num2{
			font-family: Nunito Sans, Nunito Sans;
			font-weight: 600;
			font-size: 14px;
			color: #4C4C4C;
			line-height: 36px;
			padding: 0 6px;
			background: #fff;
			text-align: center;
			min-width: 36px;
			cursor: pointer;
			margin: 0 4px;
			&.cur{
				background: #009b73;
				color: #fff;
			}
			&.none{
				cursor: default;
			}
		}
		.prev2{
			cursor: pointer;
			width: 36px;
			height: 36px;
			margin: 0 4px;
			background: url(../../assets/img/prev2.png) center center / 100% auto no-repeat;
			&.none{
				background-image: url(../../assets/img/prev3.png);
				cursor: default;
			}
		}
		.next2{
			cursor: pointer;
			width: 36px;
			height: 36px;
			margin: 0 4px;
			background: url(../../assets/img/next2.png) center center / 100% auto no-repeat;
			&.none{
				background-image: url(../../assets/img/next3.png);
				cursor: default;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/pages/pages.vue